module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/89/assets/images/94e4fd4b08789b3efe68e19416146174.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Platinum/Platinum5.svg
// module id = 27Yv
// module chunks = 1